export class ActionHandlerBuilder {
    actionIDsToHandlers = new Map();
    static new() {
        return new ActionHandlerBuilder();
    }
    with(id, handler) {
        if (this.actionIDsToHandlers.has(id)) {
            throw new Error(`IDAlreadyRegisteredError: ${id}`);
        }
        this.actionIDsToHandlers.set(id, handler);
        return this;
    }
    toHandler() {
        return (action) => this.actionIDsToHandlers.get(action.id)?.(action);
    }
}
//# sourceMappingURL=actions.js.map